import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { DefaultValues, useForm } from 'react-hook-form';
import { FieldOptionInterface } from '@families-link/shared';

type AnswerValuesFilterFormValues = {
	answerValues: [];
};

export const useAnswerFilter = () => {
	const [answerValues, setAnswerValues] = useState<FieldOptionInterface[]>([]);

	const defaultValues: DefaultValues<AnswerValuesFilterFormValues> = {
		answerValues: [],
	};

	const { register, getValues, control, watch } = useForm({
		defaultValues,
	});

	const filter = watch('answerValues');

	const debouncedUpdate = useCallback(
		debounce((list?: FieldOptionInterface[]) => {
			setAnswerValues(list || []);
		}, 300),
		[]
	);

	useEffect(() => {
		debouncedUpdate(filter);
	}, [filter, debouncedUpdate]);

	return {
		register,
		getValues,
		control,
		answerValues,
	};
};
